import { render, staticRenderFns } from "./UplimitPromotion.vue?vue&type=template&id=3b5fbfeb&scoped=true"
import script from "./UplimitPromotion.vue?vue&type=script&lang=js"
export * from "./UplimitPromotion.vue?vue&type=script&lang=js"
import style0 from "./UplimitPromotion.vue?vue&type=style&index=0&id=3b5fbfeb&prod&scoped=true&lang=css"
import style1 from "./UplimitPromotion.vue?vue&type=style&index=1&id=3b5fbfeb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5fbfeb",
  null
  
)

export default component.exports